"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var ProductResolutionMode;
(function (ProductResolutionMode) {
  ProductResolutionMode[ProductResolutionMode["Default"] = 1] = "Default";
  ProductResolutionMode[ProductResolutionMode["IdOnly"] = 2] = "IdOnly";
})(ProductResolutionMode || (ProductResolutionMode = {}));
var _default = ProductResolutionMode;
exports.default = _default;